import React from 'react';
import AppProvider from '@/contexts/AppContext';
import { Router } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import queryClient from './queryClient';
import history from './history';
import AppLayout from './layouts';
import ModalWrapper from './contexts/ModalWrapper';

import '@/languages/i18n';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-cards';
import 'react-loading-skeleton/dist/skeleton.css';
import 'photoswipe/dist/photoswipe.css';

import '@/styles/index.scss';

export default function OmegaBookingApp() {
  return (
    <ModalWrapper>
      <AppProvider>
        <Router history={history}>
          <QueryClientProvider client={queryClient}>
            <AppLayout />
          </QueryClientProvider>
        </Router>
      </AppProvider>
    </ModalWrapper>
  );
}
